export const FILTER_NEWS_REQUEST = "FILTER_NEWS_REQUEST";
export const FILTER_NEWS_SUCCESS = "FILTER_NEWS_SUCCESS";
export const FILTER_NEWS_FAILURE = "FILTER_NEWS_FAILURE";
